import HelpTooltip from '@/app/common/components/HelpTooltip';
import { guideTooltipHtml } from '../CoverageHelpTip';
import {
  getChartGuide,
  type ChartGuideKey,
} from '../../lib/chart-guides';

export function ChartHelpTip({
  guideKey,
  placement = 'top',
  className = 'ms-1',
}: {
  guideKey: ChartGuideKey;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'auto';
  className?: string;
}) {
  const guide = getChartGuide(guideKey);

  return (
    <HelpTooltip
      html={guideTooltipHtml(guide)}
      placement={placement}
      className={className}
    />
  );
}
